module.exports = __webpack_public_path__ + "img/icon-core1-2.9ae9cac0.png";